import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

let request;
export const useGymOptions = () => {
  const { api } = useAuth();
  const [options, setOptions] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    if (!request) request = api.get('/gym-classification/options').then(r => r.data).catch(e => { request = null; throw e; });
    request.then(data => { if (active) setOptions(data); }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [api]);
  return { options, error };
};